"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToCountdownTimerProps({ data, mappers }) {
    let countdownTimer = null;
    if (!('blockType' in data)) {
        countdownTimer = data;
    }
    else if (data.countdownTimerReference && typeof data.countdownTimerReference === 'object') {
        countdownTimer = data.countdownTimerReference;
    }
    const text = countdownTimer?.mainContent ? mappers.mapRichText({ richText: countdownTimer.mainContent, mappers }) : null;
    return {
        startDate: countdownTimer?.startDate,
        endDate: countdownTimer?.endDate,
        text,
        style: countdownTimer?.style,
    };
}
exports.default = mapToCountdownTimerProps;
